export default __webpack_public_path__ + "static/media/over_lose.85fd7b97.mp3";